module.exports = {"data":{"allMarkdownRemark":{"totalCount":5,"edges":[{"node":{"frontmatter":{"title":"The Kingkiller Chronicle","path":"/kingkiller"}}},{"node":{"frontmatter":{"title":"Mistborn","path":"/mistborn"}}},{"node":{"frontmatter":{"title":"The Stormlight Archive","path":"/stormlight-archive"}}},{"node":{"frontmatter":{"title":"The Dresden Files","path":"/dresden-files"}}},{"node":{"frontmatter":{"title":"The Broken Earth Trilogy Review","path":"/broken-earth"}}}]}},"pathContext":{"tag":"Fantasy"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-fantasy.json
// module id = 437
// module chunks = 145880425087474